import { Dialog, DialogContent, Box, Typography, Button, Grid } from '@mui/material';
import React, { useEffect } from 'react';
import LogoutIcon from '@mui/icons-material/Logout';
import InputIcon from '@mui/icons-material/Input';
import ErrorIcon from '@mui/icons-material/Error';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import CloudOffIcon from '@mui/icons-material/CloudOff';

export const FichadaDialog = ({ open = true, onClose, estado, data }) => {

    const horaActual = new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
    console.log(data, estado);

    useEffect(() => {
        if (!open) return;
        const timer = setTimeout(() => onClose?.(), 3000);
        return () => clearTimeout(timer);
    }, [open, onClose]);

    const tipo = data?.tipo;
    const nombre = data?.nombre ?? "Usuario";
    const horaInicio = data?.hora_inicio;
    const horaFin = data?.hora_fin;
    const total = data?.total;
    const hash = data?.hash;
    const formatearFechaHoraEspana = (fechaString) => {
        if (!fechaString) return "";

        // Convertir "YYYY-MM-DD HH:MM:SS" a "YYYY-MM-DDTHH:MM:SS"
        const normalizada = fechaString.replace(" ", "T");

        const fecha = new Date(normalizada);

        return fecha.toLocaleString("es-ES", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        });
    };

    const convertirSegundos = (segundos) => {
        const horas = Math.floor(segundos / 3600);
        const minutos = Math.floor((segundos % 3600) / 60);
        const segundosRestantes = segundos % 60;

        if (horas === 0) {
            if (minutos === 0) {
                return `${segundosRestantes} seg`;
            } else {
                return `${minutos} min`;
            }
        } else if (minutos === 0) {
            return `${horas} h`;
        } else {
            return `${horas} h ${minutos} min`;
        }
    };

    return (
        <Dialog
            open={open}
            fullScreen
            PaperProps={{
                sx: {
                    backgroundColor: "#000000ff",
                    color: "#E8F9FD",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center"
                }
            }}
        >
            <DialogContent
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 3
                }}
            >

                {/* ERROR */}
                {estado == "error" && (
                    <Grid
                        container
                        direction="column"
                        justifyContent="start"
                        alignItems="center"
                        xs={12}
                        gap={4}
                    >
                        <Typography variant="h2" sx={{ color: "#ff121e" }}>
                            <ErrorIcon sx={{ fontSize: 75, mb: -2 }} /> Fichaje erróneo
                        </Typography>

                        <Box
                            sx={{
                                width: 250,
                                height: 250,
                                backgroundColor: "#1e1e1e",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                boxShadow:
                                    tipo === "entrada"
                                        ? "0 0 20px #ff121e"
                                        : "0 0 20px #ff121e"
                            }}
                        >
                            <Typography
                                variant="h2"
                                sx={{
                                    fontWeight: "bold",
                                    color: tipo === "entrada" ? "#ff121e" : "#ff121e"
                                }}
                            >
                                {/* {tipo === "entrada" ? "✓" : "✓"} */}
                                <CloudOffIcon sx={{ fontSize: 150 }} />
                            </Typography>
                        </Box>

                        <Typography variant="h5" sx={{ opacity: 0.90 }}>
                            No se ha realizado el fichaje
                        </Typography>

                        <Button
                            onClick={onClose}
                            variant="contained"
                            size='large'
                            fullWidth
                            sx={{
                                mt: 3,
                                backgroundColor: "#ff121e",
                                transition: "0.3s",
                                "&:hover": { backgroundColor: "#ff121ed2", transition: "0.3s" }
                            }}
                        >
                            Cerrar ahora
                        </Button>
                    </Grid>

                )}

                {/* ÉXITO */}
                {estado == "success" && tipo && (
                    <Grid
                        container
                        direction="column"
                        justifyContent="start"
                        alignItems="center"
                        xs={12}
                        gap={3}
                    >
                        <Typography variant="h3">
                            {tipo === "entrada"
                                && <><InputIcon sx={{ color: "#59CE8Fff", fontSize: 60, mb: -1.7 }} /> Fichaje de entrada </>}
                            {tipo === "salida"
                                && <><LogoutIcon sx={{ color: "#61baebff", fontSize: 60, mb: -1.7 }} />  Fichaje de salida</>}
                        </Typography>

                        <Typography variant="h4">
                            {nombre}
                        </Typography>

                        <Box
                            sx={{
                                width: 250,
                                height: 250,
                                backgroundColor: "#1e1e1e",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                boxShadow:
                                    tipo === "entrada"
                                        ? "0 0 20px #59CE8F"
                                        : "0 0 20px #61baebff"
                            }}
                        >
                            <Typography
                                variant="h2"
                                sx={{
                                    fontWeight: "bold",
                                    color: tipo === "entrada" ? "#59CE8Fff" : "#61baebff"
                                }}
                            >
                                {/* {tipo === "entrada" ? "✓" : "✓"} */}
                                <CloudDoneIcon sx={{ fontSize: 150 }} />
                            </Typography>
                        </Box>

                        {/* Detalles */}
                        {tipo == "entrada" && (
                            <Typography variant="h6">
                                Inicio: {formatearFechaHoraEspana(horaInicio)}
                            </Typography>
                        )}

                        {tipo === "salida" && (
                            <>
                                <Typography variant="h6">
                                    Entrada: {formatearFechaHoraEspana(horaInicio)}
                                </Typography>
                                <Typography variant="h6">
                                    Salida: {formatearFechaHoraEspana(horaFin)}
                                </Typography>
                                <Typography variant="h6">
                                    Total: {convertirSegundos(total)}
                                </Typography>
                            </>
                        )}

                        {hash && (
                            <Typography variant="caption" sx={{ opacity: 0.4 }}>
                                Hash: {hash}
                            </Typography>
                        )}
                    </Grid>
                )}

            </DialogContent>
        </Dialog>
    );
};
